import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import userTableModel from '../../models/table.model';
import categoryType from '../../models/categoryType.model';
import { CategoryType } from '../../models/type.model';
import { useNavigate, useParams } from 'react-router-dom';
import { search_success } from '../../actions/search';
import axios from 'axios';
import environment from '../../environment';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
import { Tooltip } from 'antd';
import { HiOutlineArrowDown } from 'react-icons/hi';
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { BsTrash3 } from 'react-icons/bs';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import SelectDropdown from '../../components/common/SelectDropdown';
import methodModel from '../../methods/methods';
import datepipeModel from '../../models/datepipemodel';
import { FaEye } from 'react-icons/fa';
import { HiArrowSmUp } from 'react-icons/hi';
import statusModel from '../../models/status.model';



const faqListing = (p) => {
  let user = useSelector((state) => state.user);
  const { type } = useParams();
  const dispatch = useDispatch();
  const searchState = useSelector((state) => state.search);
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: '',
    category_id: type ? type : '',
    sortBy: 'createdAt desc',
  });
  const [Permissions, setPermissions] = useState([]);
  const [category, setcategory] = useState([]);

  const [data, setData] = useState([]);
  const [tab, setTab] = useState('list');
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(true);
  const [tableCols, setTableCols] = useState([]);
  const [form, setform] = useState(CategoryType);
  const [cattype, setcattype] = useState();
  const types = categoryType.list;
  const history = useNavigate();
  const dragItem = useRef();
  const dragOverItem = useRef();
  const dragItems = useRef();
  const dargIndex = useRef(-1);
  const dargEnterIndex = useRef(-1);

  useEffect(() => {
    getcategory()
    categoriestype();
    let cols = [];
    for (let i = 0; i <= 2; i++) {
      cols.push(userTableModel.category[i]);
    }
    setTableCols(cols);
  }, []);

  useEffect(() => {
    if (user?.role == 'subadmin' || user?.roleDetail == 'subadmin') {
      GetPermission();
    }
  }, [user]);
  useEffect(() => {
    if (user && user.loggedIn) {
      let catType = localStorage.getItem('catTypeBlog') || '';
      setFilter({
        ...filters,
        search: searchState.data,
        category_id: type ? type : catType,
      });
      getData({
        search: searchState.data,
        page: 1,
        category_id: type ? type : catType,
      });
    }
  }, [searchState, type]);

  const GetPermission = () => {
    ApiClient.get('permission/user-base', { user_id: user?.id }).then((res) => {
      if (res.success) {
        setPermissions(res?.data);
      }
    });
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key == key) {
      if (filters.sorder == 'asc') {
        sorder = 'desc';
      } else {
        sorder = 'asc';
      }
    }



    let sortBy = `${key} ${sorder}`;
    setFilter({ ...filters, sortBy, key, sorder });
    getData({ sortBy, key, sorder });
  };



  const getData = (p = {}) => {
    setLoader(true);
    let filter = { ...filters, ...p, isDeleted: false };
    ApiClient.get('all/Faq', filter).then((res) => {
      if (res.success) {
        setData(res?.data);
        setTotal(res.total);
      }
      setLoader(false);
    });
  };


  const handleItemCountChange = (e) => {
    setFilter({ ...filters, page: 1, count: e?.target?.value });
    getData({ page: 1, count: e?.target?.value });
  };
  const clear = () => {
    setFilter({ ...filters, search: '', page: 1 });
    getData({ search: '', page: 1 });
  };

  const deleteItem = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#A12238',
      cancelButtonColor: '#1e2a36',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        ApiClient.delete('faq', { id: id }).then((res) => {
          if (res.success) {
            toast.success(res?.message)
            clear();
          }
        });
      }
    });
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const ChangeRole = (e) => {
    localStorage.setItem('catTypeBlog', e);
    setFilter({ ...filters, category_id: e, page: 1 });
    getData({ category_id: e, page: 1 });
  };

  const ChangeCategory = (e) => {
    setFilter({ ...filters, parentCategory: e, page: 1 });
    getData({ parentCategory: e, page: 1 });
  };

  const exportCsv = () => {
    loader(true);
    ApiClient.get('user/csv').then((res) => {
      if (res.success) {
        let url = res.path;
        let downloadAnchor = document.getElementById('downloadJS');
        downloadAnchor.href = url;
        downloadAnchor.click();
      }
      loader(false);
    });
  };

  const UpdateStatus = (itm) => {
    console.log(itm);
    let model = 'faq';
    let status = 'active';
    if (itm.status == 'active') status = 'deactive';

    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to ${status == 'active' ? 'Activate' : 'Inactive'
        } this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#A12238',
      cancelButtonColor: '#1e2a36',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        // loader(true);
        ApiClient.put(`change/status`, {
          id: itm?.id,
          status,
          model,
        }).then((res) => {
          if (res.success) {
            getData();
          }
          // loader(false);
        });
      }
    });
  };

  const view = (id) => {
    history('/faq/view/' + id);
  };

  const edit = (id) => {
    let url = '/faq/edit/' + id;
    history(url);
  };

  const tabChange = (tab) => {
    setTab(tab);
  };

  const add = () => {
    let url = '/faq/add';
    history(url);
  };

  const reset = () => {
    let filter = {
      search: '',
      page: 1,
      parentCategory: '',
      status: '',
      category_id: type ? type : '',
    };
    setFilter({ ...filters, ...filter });
    getData({ ...filter });
    dispatch(search_success(''));
  };

  const categoriestype = () => {
    ApiClient.get(`CommonCategory/all`, {
      status: 'active',
      isDeleted: false,
      type: 'blog',
    }).then((res) => {
      if (res.success) {
        setcattype(res.data);
      }
    });
  };
  const statuschange = (value) => {
    setFilter({ ...filters, status: value, page: 1 });
    getData({ status: value, page: 1 });
  };

  const exportfun = async () => {
    const token = await localStorage.getItem('CRA_auth_token');
    let newtype = '';
    if (type == 'Reseller') {
      newtype = 'Reseller';
    }
    const req = await axios({
      method: 'get',
      url: `${environment.api}api/categories/export?catType=${newtype}`,
      responseType: 'blob',
      body: { token: token },
    });
    var blob = new Blob([req.data], {
      type: req.headers['content-type'],
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `Categories.xlsx`;
    link.click();
  };

  const dragStart = (e, position) => {
    dragItem.current = position;
    dargIndex.current = position;
  };

  const dragEnter = (e, position) => {
    let arr = document.querySelectorAll('#tableBodycat tr');
    arr.forEach((itm, i) => {
      if (i == position) {
        itm.classList.add('dragEnter');
      } else {
        itm.classList.remove('dragEnter');
      }
    });
  };

  const drop = (e) => {
    dargEnterIndex.current = -1;
    dargIndex.current = -1;
    const copyListItems = [...data];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;

    setData(copyListItems);
    let oarr = copyListItems.map((itm, i) => {
      return {
        id: itm.id,
        order: i,
      };
    });
    loader(true);
    ApiClient.put('api/category/drag/drop', { data: oarr }).then((res) => {
      if (res.success) {
        // toast.success(res.message)
      }
      loader(false);
    });
  };

  const showData = () => {
    let value = data;
    if (dragItems && dragItems.current) value = dragItems.current;
    return value;
  };

  const isAllow = (key = '') => {
    let value = Permissions?.[key];
    if (user?.roleDetail == 'admin' || user?.roleDetail == 'admin')
      value = true;
    return value;
  };
  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };

  const getcategory = () => {
    ApiClient.get(`CommonCategory/all`, { type: 'faq' }).then(res => {
      if (res?.success) {
        setcategory(res?.data)
      }
    })
  }
  return (
    <>
      <Layout>
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              {type ? 'Reseller' : ''} FAQ's
            </h3>
            <p class="text-sm font-normal text-[#525252]">
              Here you can see all about your FAQ's
            </p>
          </div>

          <div className="flex filterFlex phSpace">
            {isAllow('blog_add') ? (
              <a
                className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
                onClick={(e) => add()}
              >
                <FiPlus className="text-xl text-white" /> Add{' '}
                FAQ's
              </a>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="shadow-lg w-full bg-white rounded-lg mt-6">
          <div className="flex items-center justify-end p-4 gap-2">
            {!type ? (
              <>
                <SelectDropdown
                  id="statusDropdown"
                  displayValue="name"
                  placeholder="All Type"
                  intialValue={filters.category_id}
                  result={(e) => {
                    ChangeRole(e.value);
                  }}
                  options={category}
                  theme="search"
                />
              </>
            ) : (
              <></>
            )}

            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              intialValue={filters.status}
              result={(e) => {
                statuschange(e.value);
              }}
              options={statusModel.list}
              theme="search"
            />
            {filters.search ||
              filters.parentCategory ||
              filters.status ||
              (filters.catType && !type) ? (
              <>
                <a
                  className="bg-primary leading-10 h-10 shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg mr-2"
                  onClick={(e) => reset()}
                >
                  Reset
                </a>
              </>
            ) : (
              <></>
            )}
          </div>

          <div className="scrollbar w-full overflow-auto">
            <table class="w-full">
              <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
                <tr className="border-b border-[#EAECF0]">
                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap "
                    onClick={(e) => sorting('question')}
                  >
                    Question <span className="mr-2">{renderSortIcon('question')}</span>
                  </th>

                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                    onClick={(e) => sorting('name')}
                  >
                    Category Type{' '}
                    <span className="mr-2">
                      {renderSortIcon('name')}
                    </span>
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                    onClick={(e) => sorting('createdAt')}
                  >
                    Date Created{' '}
                    <span className="mr-2">{renderSortIcon('createdAt')}</span>
                  </th>

                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody id="tableBodycat">
                {!loaging &&
                  data &&
                  data?.map((itm, i) => {
                    return (
                      <tr className="capitalize">
                        <td
                          className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                        >
                           <Tooltip placement="right" title="View">
                          <div className="user_detail cursor-pointer" onClick={(e) => view(itm.id)}>
                            <div className="user_name">
                              <h4 className="user">
                                {methodModel.capitalizeFirstLetter(itm?.question)}
                              </h4>
                            </div>
                          </div>
                          </Tooltip>
                        </td>

                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {itm?.name}
                        </td>

                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {datepipeModel.date(itm.createdAt)}
                        </td>

                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          <div onClick={() => UpdateStatus(itm)}>
                            {/* <Tooltip placement="top" title="Active / Inactive"> */}
                            <span
                              className={`${itm.status == 'deactive'
                                  ? 'bg-[#A12238] text-[#fff]'
                                  : 'bg-[#1c2b35] text-white'
                                } text-sm w-[100px] !px-3 h-[30px] cursor-pointer flex items-center justify-center border border-[#EBEBEB] !rounded`}
                            >
                              {itm.status == 'deactive' ? 'Inactive' : 'Active'}
                            </span>
                            {/* </Tooltip> */}
                          </div>
                        </td>
                        {/* <td className='!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]'>{datepipeModel.date(itm.updatedAt)}</td> */}

                        {/* dropdown */}
                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]">
                          <div className="flex items-center gap-1.5">
                            {isAllow('blog_get') ? (
                              <>
                                <Tooltip placement="top" title="View">
                                  <a
                                    className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                    onClick={(e) => view(itm.id)}
                                  >
                                    <FaEye />
                                  </a>
                                </Tooltip>
                              </>
                            ) : (
                              <></>
                            )}
                            {isAllow('blog_edit') ? (
                              <>
                                <Tooltip placement="top" title="Edit">
                                  <a
                                    className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                    title="Edit"
                                    onClick={(e) => edit(itm?.id)}
                                  >
                                    <FiEdit3 />
                                  </a>
                                </Tooltip>
                              </>
                            ) : (
                              <></>
                            )}

                            {isAllow('blog_delete') ? (
                              <>
                                <Tooltip placement="top" title="Delete">
                                  <span
                                    className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                    onClick={() => deleteItem(itm.id)}
                                  >
                                    <BsTrash3 />
                                  </span>
                                </Tooltip>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                {/* {!loaging &&
                data &&
                showData().map((itm, i) => {
                  return (
                    <>
                      <TableRow itm={itm} index={i} />
                      {itm?.childCategories &&
                        itm?.childCategories.map((citm) => {
                          return (
                            <>
                              <TableRow
                                itm={{ ...citm, id: citm._id }}
                                index={i}
                                className="subCategory"
                                parentCategory={itm}
                              />
                              {citm.childCategories &&
                                citm.childCategories.map((sitm) => {
                                  return (
                                    <TableRow
                                      itm={{ ...sitm, id: citm._id }}
                                      index={i}
                                      className="subSubCategory"
                                      parentCategory={citm}
                                    />
                                  );
                                })}
                            </>
                          );
                        })}
                    </>
                  );
                })} */}
              </tbody>
            </table>
          </div>

          {!loaging && data?.length == 0 ? (
            <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
          ) : (
            <></>
          )}
          {!loaging && total > filters?.count ? (
            <div className="paginationWrapper  mt-15">
              <span className='text-sm text-gray-600'>Show {filters.count} from {total} Faq's</span>
              <select
                className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
                value={filters.count} // Current value of items per page
                onChange={(e) => handleItemCountChange(e)} // Function to handle changes
              >
                {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>

              <Pagination
                currentPage={filters.page}
                totalSize={total}
                sizePerPage={filters.count}
                changeCurrentPage={pageChange}
              />

            </div>
          ) : (
            <></>
          )}
          {loaging ? (
            <div className="text-center py-4">
              <img src="/assets/img/loader.gif" className="pageLoader" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </Layout>
    </>
  );
};

export default faqListing;
